// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v4pZ","icon":"styles_icon__J_kKN"};